/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MoreRouteImport } from './routes/more'
import { Route as MoneyRouteImport } from './routes/money'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HealthRouteImport } from './routes/health'
import { Route as FamilyRouteImport } from './routes/family'
import { Route as DryvnRouteImport } from './routes/dryvn'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MoreIndexRouteImport } from './routes/more.index'
import { Route as MoreVehiclesRouteImport } from './routes/more.vehicles'
import { Route as MoreVaultRouteImport } from './routes/more.vault'
import { Route as MoreShoppingRouteImport } from './routes/more.shopping'
import { Route as MoreSettingsRouteImport } from './routes/more.settings'
import { Route as MoreReadingRouteImport } from './routes/more.reading'
import { Route as MoreLegacyRouteImport } from './routes/more.legacy'
import { Route as MoreJournalRouteImport } from './routes/more.journal'
import { Route as MoreDatesRouteImport } from './routes/more.dates'
import { Route as MoreSettingsIndexRouteImport } from './routes/more.settings.index'
import { Route as MoreSettingsNotificationsRouteImport } from './routes/more.settings.notifications'
import { Route as MoreSettingsIntegrationsRouteImport } from './routes/more.settings.integrations'
import { Route as MoreSettingsApiRouteImport } from './routes/more.settings.api'

const MoreRoute = MoreRouteImport.update({
  id: '/more',
  path: '/more',
  getParentRoute: () => rootRouteImport,
} as any)
const MoneyRoute = MoneyRouteImport.update({
  id: '/money',
  path: '/money',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthRoute = HealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => rootRouteImport,
} as any)
const FamilyRoute = FamilyRouteImport.update({
  id: '/family',
  path: '/family',
  getParentRoute: () => rootRouteImport,
} as any)
const DryvnRoute = DryvnRouteImport.update({
  id: '/dryvn',
  path: '/dryvn',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreIndexRoute = MoreIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MoreRoute,
} as any)
const MoreVehiclesRoute = MoreVehiclesRouteImport.update({
  id: '/vehicles',
  path: '/vehicles',
  getParentRoute: () => MoreRoute,
} as any)
const MoreVaultRoute = MoreVaultRouteImport.update({
  id: '/vault',
  path: '/vault',
  getParentRoute: () => MoreRoute,
} as any)
const MoreShoppingRoute = MoreShoppingRouteImport.update({
  id: '/shopping',
  path: '/shopping',
  getParentRoute: () => MoreRoute,
} as any)
const MoreSettingsRoute = MoreSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => MoreRoute,
} as any)
const MoreReadingRoute = MoreReadingRouteImport.update({
  id: '/reading',
  path: '/reading',
  getParentRoute: () => MoreRoute,
} as any)
const MoreLegacyRoute = MoreLegacyRouteImport.update({
  id: '/legacy',
  path: '/legacy',
  getParentRoute: () => MoreRoute,
} as any)
const MoreJournalRoute = MoreJournalRouteImport.update({
  id: '/journal',
  path: '/journal',
  getParentRoute: () => MoreRoute,
} as any)
const MoreDatesRoute = MoreDatesRouteImport.update({
  id: '/dates',
  path: '/dates',
  getParentRoute: () => MoreRoute,
} as any)
const MoreSettingsIndexRoute = MoreSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MoreSettingsRoute,
} as any)
const MoreSettingsNotificationsRoute =
  MoreSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => MoreSettingsRoute,
  } as any)
const MoreSettingsIntegrationsRoute =
  MoreSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => MoreSettingsRoute,
  } as any)
const MoreSettingsApiRoute = MoreSettingsApiRouteImport.update({
  id: '/api',
  path: '/api',
  getParentRoute: () => MoreSettingsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dryvn': typeof DryvnRoute
  '/family': typeof FamilyRoute
  '/health': typeof HealthRoute
  '/login': typeof LoginRoute
  '/money': typeof MoneyRoute
  '/more': typeof MoreRouteWithChildren
  '/more/dates': typeof MoreDatesRoute
  '/more/journal': typeof MoreJournalRoute
  '/more/legacy': typeof MoreLegacyRoute
  '/more/reading': typeof MoreReadingRoute
  '/more/settings': typeof MoreSettingsRouteWithChildren
  '/more/shopping': typeof MoreShoppingRoute
  '/more/vault': typeof MoreVaultRoute
  '/more/vehicles': typeof MoreVehiclesRoute
  '/more/': typeof MoreIndexRoute
  '/more/settings/api': typeof MoreSettingsApiRoute
  '/more/settings/integrations': typeof MoreSettingsIntegrationsRoute
  '/more/settings/notifications': typeof MoreSettingsNotificationsRoute
  '/more/settings/': typeof MoreSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dryvn': typeof DryvnRoute
  '/family': typeof FamilyRoute
  '/health': typeof HealthRoute
  '/login': typeof LoginRoute
  '/money': typeof MoneyRoute
  '/more/dates': typeof MoreDatesRoute
  '/more/journal': typeof MoreJournalRoute
  '/more/legacy': typeof MoreLegacyRoute
  '/more/reading': typeof MoreReadingRoute
  '/more/shopping': typeof MoreShoppingRoute
  '/more/vault': typeof MoreVaultRoute
  '/more/vehicles': typeof MoreVehiclesRoute
  '/more': typeof MoreIndexRoute
  '/more/settings/api': typeof MoreSettingsApiRoute
  '/more/settings/integrations': typeof MoreSettingsIntegrationsRoute
  '/more/settings/notifications': typeof MoreSettingsNotificationsRoute
  '/more/settings': typeof MoreSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dryvn': typeof DryvnRoute
  '/family': typeof FamilyRoute
  '/health': typeof HealthRoute
  '/login': typeof LoginRoute
  '/money': typeof MoneyRoute
  '/more': typeof MoreRouteWithChildren
  '/more/dates': typeof MoreDatesRoute
  '/more/journal': typeof MoreJournalRoute
  '/more/legacy': typeof MoreLegacyRoute
  '/more/reading': typeof MoreReadingRoute
  '/more/settings': typeof MoreSettingsRouteWithChildren
  '/more/shopping': typeof MoreShoppingRoute
  '/more/vault': typeof MoreVaultRoute
  '/more/vehicles': typeof MoreVehiclesRoute
  '/more/': typeof MoreIndexRoute
  '/more/settings/api': typeof MoreSettingsApiRoute
  '/more/settings/integrations': typeof MoreSettingsIntegrationsRoute
  '/more/settings/notifications': typeof MoreSettingsNotificationsRoute
  '/more/settings/': typeof MoreSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dryvn'
    | '/family'
    | '/health'
    | '/login'
    | '/money'
    | '/more'
    | '/more/dates'
    | '/more/journal'
    | '/more/legacy'
    | '/more/reading'
    | '/more/settings'
    | '/more/shopping'
    | '/more/vault'
    | '/more/vehicles'
    | '/more/'
    | '/more/settings/api'
    | '/more/settings/integrations'
    | '/more/settings/notifications'
    | '/more/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dryvn'
    | '/family'
    | '/health'
    | '/login'
    | '/money'
    | '/more/dates'
    | '/more/journal'
    | '/more/legacy'
    | '/more/reading'
    | '/more/shopping'
    | '/more/vault'
    | '/more/vehicles'
    | '/more'
    | '/more/settings/api'
    | '/more/settings/integrations'
    | '/more/settings/notifications'
    | '/more/settings'
  id:
    | '__root__'
    | '/'
    | '/dryvn'
    | '/family'
    | '/health'
    | '/login'
    | '/money'
    | '/more'
    | '/more/dates'
    | '/more/journal'
    | '/more/legacy'
    | '/more/reading'
    | '/more/settings'
    | '/more/shopping'
    | '/more/vault'
    | '/more/vehicles'
    | '/more/'
    | '/more/settings/api'
    | '/more/settings/integrations'
    | '/more/settings/notifications'
    | '/more/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DryvnRoute: typeof DryvnRoute
  FamilyRoute: typeof FamilyRoute
  HealthRoute: typeof HealthRoute
  LoginRoute: typeof LoginRoute
  MoneyRoute: typeof MoneyRoute
  MoreRoute: typeof MoreRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/more': {
      id: '/more'
      path: '/more'
      fullPath: '/more'
      preLoaderRoute: typeof MoreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/money': {
      id: '/money'
      path: '/money'
      fullPath: '/money'
      preLoaderRoute: typeof MoneyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health': {
      id: '/health'
      path: '/health'
      fullPath: '/health'
      preLoaderRoute: typeof HealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/family': {
      id: '/family'
      path: '/family'
      fullPath: '/family'
      preLoaderRoute: typeof FamilyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dryvn': {
      id: '/dryvn'
      path: '/dryvn'
      fullPath: '/dryvn'
      preLoaderRoute: typeof DryvnRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/': {
      id: '/more/'
      path: '/'
      fullPath: '/more/'
      preLoaderRoute: typeof MoreIndexRouteImport
      parentRoute: typeof MoreRoute
    }
    '/more/vehicles': {
      id: '/more/vehicles'
      path: '/vehicles'
      fullPath: '/more/vehicles'
      preLoaderRoute: typeof MoreVehiclesRouteImport
      parentRoute: typeof MoreRoute
    }
    '/more/vault': {
      id: '/more/vault'
      path: '/vault'
      fullPath: '/more/vault'
      preLoaderRoute: typeof MoreVaultRouteImport
      parentRoute: typeof MoreRoute
    }
    '/more/shopping': {
      id: '/more/shopping'
      path: '/shopping'
      fullPath: '/more/shopping'
      preLoaderRoute: typeof MoreShoppingRouteImport
      parentRoute: typeof MoreRoute
    }
    '/more/settings': {
      id: '/more/settings'
      path: '/settings'
      fullPath: '/more/settings'
      preLoaderRoute: typeof MoreSettingsRouteImport
      parentRoute: typeof MoreRoute
    }
    '/more/reading': {
      id: '/more/reading'
      path: '/reading'
      fullPath: '/more/reading'
      preLoaderRoute: typeof MoreReadingRouteImport
      parentRoute: typeof MoreRoute
    }
    '/more/legacy': {
      id: '/more/legacy'
      path: '/legacy'
      fullPath: '/more/legacy'
      preLoaderRoute: typeof MoreLegacyRouteImport
      parentRoute: typeof MoreRoute
    }
    '/more/journal': {
      id: '/more/journal'
      path: '/journal'
      fullPath: '/more/journal'
      preLoaderRoute: typeof MoreJournalRouteImport
      parentRoute: typeof MoreRoute
    }
    '/more/dates': {
      id: '/more/dates'
      path: '/dates'
      fullPath: '/more/dates'
      preLoaderRoute: typeof MoreDatesRouteImport
      parentRoute: typeof MoreRoute
    }
    '/more/settings/': {
      id: '/more/settings/'
      path: '/'
      fullPath: '/more/settings/'
      preLoaderRoute: typeof MoreSettingsIndexRouteImport
      parentRoute: typeof MoreSettingsRoute
    }
    '/more/settings/notifications': {
      id: '/more/settings/notifications'
      path: '/notifications'
      fullPath: '/more/settings/notifications'
      preLoaderRoute: typeof MoreSettingsNotificationsRouteImport
      parentRoute: typeof MoreSettingsRoute
    }
    '/more/settings/integrations': {
      id: '/more/settings/integrations'
      path: '/integrations'
      fullPath: '/more/settings/integrations'
      preLoaderRoute: typeof MoreSettingsIntegrationsRouteImport
      parentRoute: typeof MoreSettingsRoute
    }
    '/more/settings/api': {
      id: '/more/settings/api'
      path: '/api'
      fullPath: '/more/settings/api'
      preLoaderRoute: typeof MoreSettingsApiRouteImport
      parentRoute: typeof MoreSettingsRoute
    }
  }
}

interface MoreSettingsRouteChildren {
  MoreSettingsApiRoute: typeof MoreSettingsApiRoute
  MoreSettingsIntegrationsRoute: typeof MoreSettingsIntegrationsRoute
  MoreSettingsNotificationsRoute: typeof MoreSettingsNotificationsRoute
  MoreSettingsIndexRoute: typeof MoreSettingsIndexRoute
}

const MoreSettingsRouteChildren: MoreSettingsRouteChildren = {
  MoreSettingsApiRoute: MoreSettingsApiRoute,
  MoreSettingsIntegrationsRoute: MoreSettingsIntegrationsRoute,
  MoreSettingsNotificationsRoute: MoreSettingsNotificationsRoute,
  MoreSettingsIndexRoute: MoreSettingsIndexRoute,
}

const MoreSettingsRouteWithChildren = MoreSettingsRoute._addFileChildren(
  MoreSettingsRouteChildren,
)

interface MoreRouteChildren {
  MoreDatesRoute: typeof MoreDatesRoute
  MoreJournalRoute: typeof MoreJournalRoute
  MoreLegacyRoute: typeof MoreLegacyRoute
  MoreReadingRoute: typeof MoreReadingRoute
  MoreSettingsRoute: typeof MoreSettingsRouteWithChildren
  MoreShoppingRoute: typeof MoreShoppingRoute
  MoreVaultRoute: typeof MoreVaultRoute
  MoreVehiclesRoute: typeof MoreVehiclesRoute
  MoreIndexRoute: typeof MoreIndexRoute
}

const MoreRouteChildren: MoreRouteChildren = {
  MoreDatesRoute: MoreDatesRoute,
  MoreJournalRoute: MoreJournalRoute,
  MoreLegacyRoute: MoreLegacyRoute,
  MoreReadingRoute: MoreReadingRoute,
  MoreSettingsRoute: MoreSettingsRouteWithChildren,
  MoreShoppingRoute: MoreShoppingRoute,
  MoreVaultRoute: MoreVaultRoute,
  MoreVehiclesRoute: MoreVehiclesRoute,
  MoreIndexRoute: MoreIndexRoute,
}

const MoreRouteWithChildren = MoreRoute._addFileChildren(MoreRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DryvnRoute: DryvnRoute,
  FamilyRoute: FamilyRoute,
  HealthRoute: HealthRoute,
  LoginRoute: LoginRoute,
  MoneyRoute: MoneyRoute,
  MoreRoute: MoreRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
